import initializer from '@/lib/initializer'
import lazyModule from '@/lib/lazy-module'
import 'vite/modulepreload-polyfill'
import { initDisclosureWidgets } from '@/lib/a11y'
import revive from '@/lib/revive.js'
import { initTabKeyListener } from '@/lib/accessibility'
import { initBluecore } from '@/lib/bluecore'
import scrollAnimation from '@/lib/scroll-animation'
import sal from 'sal.js'

const islands = import.meta.glob('@/islands/**.js')
const summaries = document.querySelectorAll('[id^="Details-"] summary')

revive(islands)
initDisclosureWidgets(summaries)

if (window.decodeURI(window.location.pathname) === '/account/addresses') {
  import('@/lib/shopify_common')
  import('@/lib/customer-address')
}

import picture from '../../modules/picture/picture'
import productCardMixin from '../../modules/product-card/product-card-mixin'
import carouselSwiper from '../../modules/carousel-swiper/carousel-swiper'
import header from '../../modules/header/header'
import footer from '../../modules/footer/footer'
import promobar from '../../modules/promobar/promobar'
import cartGrid from '../../modules/cart-grid/cart-grid'
import miniCart from '../../modules/mini-cart/mini-cart'
import heroShort from '../../modules/hero-short/hero-short'
import plp from '../../modules/plp/plp'
import emailCollection from '../../modules/email-collection/email-collection'
const newsletterForm = lazyModule('newsletterForm', { offset: 120 })

document.addEventListener('DOMContentLoaded', () => {
  initializer({
    picture,
    productCardMixin,
    carouselSwiper,
    promobar,
    header,
    heroShort,
    cartGrid,
    miniCart,
    footer,
    plp,
    emailCollection,
    newsletterForm
  })

  initTabKeyListener()
  scrollAnimation()
  initBluecore()
  // Do not remove "window.scrollAnimations" because it's currently used in multiple places
  window.scrollAnimations = sal({
    threshold: 0.1,
  })
})